export default class ShopProductStars extends HTMLElement {
    private productId: string | null = null
    private ratingEl: HTMLElement | null = null
    private countEl: HTMLElement | null = null

    // private apikey: string | null = 'pk_9fe8f763ad3666b5d941898c179875cc4d'

    constructor() {
        super()

        this.productId = this.getAttribute('product-id')

        this.ratingEl = this.querySelector('[data-rating]')
        this.countEl = this.querySelector('[data-count]')
    }

    connectedCallback() {
        // @ts-ignore
        if (this.productId && this.okendoUserId) {
            this.fetchProductReviews()
        }
    }

    private async fetchProductReviews() {
        try {
            // @ts-ignore
            const response = await fetch(`https://api.okendo.io/v1/stores/${this.okendoUserId}/products/shopify-${this.productId}/reviews`)

            if (!response.ok) {
                throw new Error('Failed to fetch reviews')
            }

            const data = await response.json()
            this.updateStars(data)
        } catch (error) {
            console.error('Error fetching Okendo reviews:', error)
        }
    }

    private updateStars(data: any) {
        console.log('data', data)
        if (!data || !this.ratingEl || !this.countEl) return

        const rating = data.aggregates?.average_rating || 0
        const count = data.total_reviews || 0

        // Update rating display
        this.ratingEl.textContent = `(${rating.toFixed(1)} ★)`

        // Update review count
        this.countEl.textContent = `${count} ${count === 1 ? 'review' : 'reviews'}`

        // Dispatch event for other components that might need this data
        window.dispatchEvent(
            new CustomEvent('product:reviews:loaded', {
                bubbles: true,
                detail: { rating, count },
            })
        )
    }
}

customElements.define('shop-product-stars', ShopProductStars)
